/**
 * LocationProvider compartido para microservicios A365
 * 
 * Proporciona una interfaz unificada para geolocalización
 * usando los observables procesados de @a365/core, eliminando la necesidad
 * de múltiples implementaciones duplicadas.
 */

import React, { createContext, useContext, useEffect, useState } from "react";
import { processedGeo$ } from "../services/geolocationService";

const LocationContext = createContext();

export const useLocation = () => {
  const context = useContext(LocationContext);
  if (!context) {
    throw new Error('useLocation debe utilizarse dentro de un LocationProvider');
  }
  return context;
};

/**
 * LocationProvider compartido que usa geo$ observable
 * Compatible con todas las implementaciones existentes
 */
export const LocationProvider = ({ children, additionalData = {} }) => {
  const [geolocation, setGeoLocation] = useState(null);

  useEffect(() => {
    const subscription = processedGeo$.subscribe((data) => {
      // Solo actualizar el estado si los datos no están vacíos o si es el primer valor
      if (data && Object.keys(data).length > 0) {
        setGeoLocation(prevData => {
          // Si es la primera vez o si los nuevos datos tienen más información, actualizamos
          if (!prevData || !prevData.sales_number || data.sales_number) {
            return data;
          }
          // Si los nuevos datos tienen menos campos o no tienen sales_number, mantener el estado anterior
          return prevData;
        });
      }
    });

    return () => {
      subscription.unsubscribe();
    };
  }, []);

  const contextValue = {
    geolocation,
    ...additionalData, // Permite extensión para casos específicos
  };

  return (
    <LocationContext.Provider value={contextValue}>
      {children}
    </LocationContext.Provider>
  );
};

// Re-exportar el contexto para casos específicos
export { LocationContext };
